import { env } from '~/lib/env';
import { useUser } from '~/modules/auth/hooks/useUser';

// NOTE: Artist contact information is confidential.
//       Only add yourself to this list if you need to test this feature.
const ENABLED_EMAILS = [
  'rk@wmg.com',
  'lawrence.kennedy@wmg.com',
  'irfan.ebrahim@wmg.com',
  'florian.krauthan@wmg.com',
  'tiffany.yu@wmg.com',
  'yifan.wu@wmg.com',
  'thayer.altman@wmg.com',
];

export function useIsContactInfoEnabled() {
  const user = useUser();
  if (env('VITE_WMG_ARTIST_CONTACTS_ENABLED') !== 'true') {
    return false;
  }

  return ENABLED_EMAILS.some((email) => email === user.email.toLowerCase());
}
